export default __webpack_public_path__ + "static/media/jugaxjugar18.ee81a984.png";